module.exports = __webpack_public_path__ + "media/bootstrap-icons/node-minus-fill-c921b656.svg";